import { render } from "./News41.vue?vue&type=template&id=2d878210"
import script from "./News41.vue?vue&type=script&lang=js"
export * from "./News41.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__